function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CashCoin, Truck, CartCheckFill, WalletFill, Shop, PersonFillLock, Speedometer, MicrosoftTeams, BoxSeamFill, EmojiSmileUpsideDown, Power, EnvelopePlusFill, Diagram3Fill, PeopleFill } from 'react-bootstrap-icons';
import { Container, Row, Col } from "react-bootstrap";
import SportsModeIcon from '@iconify-react/flat-color-icons/sports-mode';
import ShopIcon from '@iconify-react/flat-color-icons/shop';
import { Outlet, useNavigate } from 'react-router-dom';
import { Layout, Menu, Modal, message, Image } from 'antd';
import AddMail from '../components/forms/AddMail';
var Header = Layout.Header,
  Content = Layout.Content,
  Footer = Layout.Footer,
  Sider = Layout.Sider;
import Common from '../components/includes/Common';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubMenu = Menu.SubMenu;
var Home = function Home() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNewMailModalOpen = _useState2[0],
    setIsNewMailModalOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    currentMenuItem = _useState4[0],
    setCurrentMenuItem = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMailCreated = _useState6[0],
    setIstMailCreated = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    collapsed = _useState8[0],
    setCollapsed = _useState8[1];
  var navigate = useNavigate();
  var handleMenuClick = function handleMenuClick(e) {
    setCurrentMenuItem(e.key);
    if (e.key == 'summary') {
      navigate('/home/dashboard');
    }
    if (e.key == 'sales') {
      navigate('/home/sales');
    }
    if (e.key == 'delivery') {
      navigate('/home/delivery');
    }
    if (e.key == 'pay') {
      navigate('/home/payments');
    }
    if (e.key == 'rep') {
      navigate('/home/accountant');
    }
    if (e.key == 'items') {
      navigate('/home/sellables');
    }
    if (e.key == 'shops') {
      navigate('/home/shops');
    }
    if (e.key == 'stock') {
      navigate('/home/stock');
    }
    if (e.key == 'provider') {
      navigate('/home/providers');
    }
    if (e.key == 'users') {
      navigate('/home/users');
    }
    if (e.key == 'account') {
      navigate('/home/account');
    }
    if (e.key == 'quit') {
      axios.post(Common.baseApiUrl + 'logout').then(function (response) {
        if (response.data.status == 200) {
          localStorage.clear();
          navigate('/');
        }
      })["catch"](function (error) {});
    }
  };
  var mailAddedHandler = function mailAddedHandler() {
    setIsNewMailModalOpen(false);
    setIstMailCreated(true);
    message.success({
      content: 'Courrier enregistré avec succès',
      delay: 4
    });
  };
  return /*#__PURE__*/_jsxs(Layout, {
    style: {
      minHeight: '100vh'
    },
    children: [/*#__PURE__*/_jsxs(Sider, {
      collapsible: true,
      collapsed: collapsed,
      onCollapse: function onCollapse(value) {
        return setCollapsed(value);
      },
      style: {
        background: '#CCCCD5'
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          height: 32,
          margin: "16px 16px 16px 16px",
          background: 'rgba(255, 255, 255, 0.2)'
        }
      }), /*#__PURE__*/_jsxs(Menu, {
        theme: "light",
        style: {
          background: '#DDDDE5'
        },
        subMenuCloseDelay: 60,
        defaultSelectedKeys: ['dash'],
        onClick: handleMenuClick,
        children: [Common.currentUser.role == 99 && /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(Speedometer, {
            color: "#1D4E94",
            size: 24
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#1D4E94"
            },
            children: "Tabl. de bord"
          })
        }, "summary"), Common.currentUser.role == 99 && /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(CashCoin, {
            color: "#1D4E94",
            size: 24
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#1D4E94"
            },
            children: "Ventes"
          })
        }, "sales"), Common.currentUser.role == 99 && /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(BoxSeamFill, {
            color: "#1D4E94",
            size: 24
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#1D4E94"
            },
            children: "Etat du stock"
          })
        }, "stock"), Common.currentUser.role == 99 && /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(Truck, {
            color: "#1D4E94",
            size: 24
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#1D4E94"
            },
            children: "Fournisseurs"
          })
        }, "provider"), Common.currentUser.role == 99 && /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(SportsModeIcon, {
            height: "36px"
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#1D4E94"
            },
            children: "Livraisons"
          })
        }, "delivery"), (Common.currentUser.role == 99 || Common.currentUser.role == 70) && /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(WalletFill, {
            style: {
              color: "#0447A5"
            },
            size: 24
          }),
          children: /*#__PURE__*/_jsx("b", {
            children: "Versements"
          })
        }, "pay"), Common.currentUser.role == 99 && /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(CartCheckFill, {
            color: "#1D4E94",
            size: 24
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#1D4E94"
            },
            children: "Articles"
          })
        }, "items"), Common.currentUser.role == 99 && /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(ShopIcon, {
            height: "30px"
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#1D4E94"
            },
            children: "Boutiques"
          })
        }, "shops"), Common.currentUser.role == 99 && /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(PeopleFill, {
            color: "#1D4E94",
            size: 24
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#1D4E94"
            },
            children: "Utilisateurs"
          })
        }, "users"), /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(PersonFillLock, {
            color: "#1D4E94",
            size: 24
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#1D4E94"
            },
            children: "Mon compte"
          })
        }, "account"), /*#__PURE__*/_jsx(Menu.Item, {
          icon: /*#__PURE__*/_jsx(Power, {
            color: "#C28A79",
            size: 28
          }),
          children: /*#__PURE__*/_jsx("b", {
            style: {
              color: "#C28A79"
            },
            children: "QUITTER"
          })
        }, "quit")]
      })]
    }), /*#__PURE__*/_jsxs(Layout, {
      className: "site-layout",
      children: [/*#__PURE__*/_jsx(Header, {
        style: {
          padding: 0,
          background: 'red'
        },
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 2,
              md: 2,
              sm: 4,
              xs: 4,
              children: /*#__PURE__*/_jsx(Image, {
                src: "drawables/alo.png",
                preview: false,
                width: 120
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: {
                span: 3,
                offset: 7
              },
              md: {
                span: 3,
                offset: 7
              },
              sm: {
                span: 6,
                offset: 2
              },
              xs: {
                span: 6,
                offset: 1
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(EmojiSmileUpsideDown, {
                  size: 20
                }), " Bonjour, ", Common.currentUser.prenom]
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Content, {
        className: "site-layout",
        style: {
          padding: '0 0px',
          marginTop: 6
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "site-layout-background",
          style: {
            padding: 8,
            minHeight: 380
          },
          children: /*#__PURE__*/_jsx(Outlet, {
            context: [isMailCreated, setIstMailCreated]
          })
        })
      }), /*#__PURE__*/_jsx(Footer, {
        style: {
          textAlign: 'center'
        },
        children: "Guisoft Lab \xA92022, tous droits r\xE9serv\xE9s"
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      destroyOnClose: true,
      open: isNewMailModalOpen,
      onCancel: function onCancel() {
        setIsNewMailModalOpen(false);
      },
      footer: null,
      title: /*#__PURE__*/_jsxs("b", {
        children: ["NOUVEAU COURRIER ", /*#__PURE__*/_jsx(EnvelopePlusFill, {
          size: 20
        })]
      }),
      width: "70%",
      children: /*#__PURE__*/_jsx(AddMail, {
        handler: mailAddedHandler
      })
    })]
  });
};
export default Home;